import { render, staticRenderFns } from "./ContatoTelefoneLista.vue?vue&type=template&id=20d9936b&scoped=true&"
import script from "./ContatoTelefoneLista.vue?vue&type=script&lang=js&"
export * from "./ContatoTelefoneLista.vue?vue&type=script&lang=js&"
import style0 from "./ContatoTelefoneLista.vue?vue&type=style&index=0&id=20d9936b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d9936b",
  null
  
)

export default component.exports